// src/lang/index.js
import { createI18n } from 'vue-i18n'; // Vue 3 语法
import zh from './zh';
import en from './en';

// 读取本地存储的语言偏好（优先用户之前选择的语言）
const storedLang = localStorage.getItem('appLanguage') || 'zh';

const i18n = createI18n({
  legacy: false, // 关闭 legacy 模式，支持 Composition API
  locale: storedLang, // 默认语言
  messages: { zh, en } // 语言包
});

export default i18n;